import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const DeleteReaderModal = ({ visible, onCancel, onConfirm }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Confirm"
      cancelText="Cancel"
      okButtonProps={{
        danger: true,
        className: "bg-red-600 hover:bg-red-700 text-white font-medium",
      }}
      centered
      width={400}
      title={
        <div className="flex flex-col items-center text-center">
          <ExclamationCircleOutlined className="text-red-500 text-4xl mb-2" />
          <h2 className="text-lg font-semibold">Confirm Delete</h2>
        </div>
      }
    >
      <div className="text-center text-gray-600">
        <p>Are you sure you want to delete this reader?</p>
        <p className="mt-1 text-sm text-gray-500">
          This action will deactivate the reader’s account but keep the record for reference.
        </p>
      </div>
    </Modal>
  );
};

export default DeleteReaderModal;
